/* =========================================================
   scroll-fx.js
   Two small, dependency-free scroll effects:
     1. A pinned progress bar showing how far down the page you are
     2. Real scroll-linked parallax on hero / banner / slideshow images
   Both respect prefers-reduced-motion.
   ========================================================= */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function throttleToFrame(fn) {
    var ticking = false;
    return function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        fn();
        ticking = false;
      });
    };
  }

  function initProgressBar() {
    var bar = document.createElement('div');
    bar.id = 'scroll-fx-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    function update() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var progress = docHeight > 0 ? Math.min(100, Math.max(0, (scrollTop / docHeight) * 100)) : 0;
      bar.style.width = progress + '%';
    }

    window.addEventListener('scroll', throttleToFrame(update), { passive: true });
    window.addEventListener('resize', throttleToFrame(update), { passive: true });
    update();
  }

  function initParallax() {
    if (prefersReducedMotion || window.innerWidth < 750) return;

    var images = Array.prototype.slice.call(
      document.querySelectorAll('.banner__media img, .slideshow__media img')
    );
    if (!images.length) return;

    images.forEach(function (img) {
      img.setAttribute('data-scroll-fx-parallax', '');
      img.style.transform = 'scale(1.1)';
    });

    function update() {
      var viewportH = window.innerHeight;
      images.forEach(function (img) {
        var rect = img.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > viewportH + 200) return;
        var offset = (rect.top - viewportH / 2) * 0.12;
        img.style.transform = 'translateY(' + offset.toFixed(1) + 'px) scale(1.1)';
      });
    }

    window.addEventListener('scroll', throttleToFrame(update), { passive: true });
    window.addEventListener('resize', throttleToFrame(update), { passive: true });
    update();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProgressBar();
    initParallax();
  });
})();
